import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "text-align": "left"
  }
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "text-align": "left",
    "max-width": "250px"
  }
};
var _hoisted_3 = {
  key: 0
};
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import { px2vw } from '@/utils/phoneConfig';
export default {
  __name: 'BuyTopBanner',
  props: {
    popHeight: {
      type: String
    },
    asinDetails: {
      type: Object
    }
  },
  setup(__props) {
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var countryName = computed(() => {
      var _constants$MERCHANT_B, _constants$MERCHANT_B2, _constants$MERCHANT_B3, _props$asinDetails;
      return (_constants$MERCHANT_B = (_constants$MERCHANT_B2 = constants.MERCHANT_BADGE_MAP) === null || _constants$MERCHANT_B2 === void 0 ? void 0 : (_constants$MERCHANT_B3 = _constants$MERCHANT_B2[(_props$asinDetails = props.asinDetails) === null || _props$asinDetails === void 0 ? void 0 : _props$asinDetails.merchantId]) === null || _constants$MERCHANT_B3 === void 0 ? void 0 : _constants$MERCHANT_B3.badgeName) !== null && _constants$MERCHANT_B !== void 0 ? _constants$MERCHANT_B : '';
    });
    var freeShippingText = computed(() => {
      var _props$asinDetails2, _props$asinDetails2$d;
      return (_props$asinDetails2 = props.asinDetails) !== null && _props$asinDetails2 !== void 0 && (_props$asinDetails2$d = _props$asinDetails2.delivery) !== null && _props$asinDetails2$d !== void 0 && _props$asinDetails2$d.isGlobalStoreFreeShippingProgram ? t('common.ELIGIBLE_FREE_SHIPPING') : '';
    });
    var postalText = computed(() => {
      var _props$asinDetails3;
      return ((_props$asinDetails3 = props.asinDetails) === null || _props$asinDetails3 === void 0 ? void 0 : _props$asinDetails3.nonReturnableFlag) === '1' ? t('modules.checkout.NOT_ELIGIBLE_FOR_UNCONDITIONAL_RETURN') : t('common.DOOR_TO_DOOR_PICK_UP_AND_RETURN');
    });
    return (_ctx, _cache) => {
      return countryName.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "prompt-text",
        style: _normalizeStyle({
          bottom: `calc(${__props.popHeight} + ${_unref(px2vw)(24)}`
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('common.SOLD_BY')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.AUTHENTIC_GUARANTEE')), 1)]), _createElementVNode("div", _hoisted_2, [freeShippingText.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(freeShippingText.value), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(postalText.value), 1)])], 4)) : _createCommentVNode("", true);
    };
  }
};